import { motion } from "framer-motion";

export const Sparkline = ({ points, width = 110, height = 30, stroke = "#d4af37", className = "", fill = false, testid }) => {
  if (!points || points.length === 0) return null;
  const pts = points.length === 1 ? [points[0], points[0]] : points;
  const min = Math.min(...pts);
  const max = Math.max(...pts);
  const range = max - min || 1;
  const line = pts
    .map((p, i) => `${i === 0 ? "M" : "L"}${((i / (pts.length - 1)) * width).toFixed(1)},${(height - 3 - ((p - min) / range) * (height - 6)).toFixed(1)}`)
    .join(" ");
  const lastX = width;
  const lastY = height - 3 - ((pts[pts.length - 1] - min) / range) * (height - 6);
  const gid = `sl-${stroke.replace("#", "")}-${pts.length}`;
  return (
    <svg
      data-testid={testid}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      width={width}
      height={height}
      className={className}
    >
      {fill && (
        <>
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={stroke} stopOpacity="0.28" />
              <stop offset="100%" stopColor={stroke} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={`${line} L${width},${height} L0,${height} Z`} fill={`url(#${gid})`} stroke="none" />
        </>
      )}
      <motion.path
        d={line}
        fill="none"
        stroke={stroke}
        strokeWidth="1.8"
        strokeLinecap="round"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: "easeOut" }}
      />
      <circle cx={lastX} cy={lastY} r="2.2" fill={stroke} />
    </svg>
  );
};
